import {useState, useEffect} from "react";
import {ReactComponent as Fold} from "assets/image/Layout/PropertyPanel/ic_dropdown_fold.svg";
import {ReactComponent as Unfold} from "assets/image/Layout/PropertyPanel/ic_dropdown_unfold.svg";
import {ReactComponent as Check} from "assets/image/Common/ic_check_white.svg";

import styles from "./index.module.scss";
import SelectDropDown from "components/Common/Dropdown/SelectDropDown";

const MultipleDropDownInput = ({name, arrays = {}, dropdownOnChange, values = {}, selectedObject, dropdownOpened, setDropdownOpened}) => {
  const currentSelectedObj = {};
  Object.keys(arrays).map(subName => {
    currentSelectedObj[subName] = values[subName];
  });
  const [currentSelected, setCurrentSelected] = useState(currentSelectedObj);

  useEffect(() => {
    Object.keys(arrays).map(subName => {
      currentSelectedObj[subName] = values[subName];
    });
    setCurrentSelected(currentSelectedObj);
  }, [selectedObject]);

  return (
    <div className={styles.container}>
      <p className={styles.title}>{name}</p>
      <div className={styles.inputs_wrapper}>
        {Object.entries(arrays).map(([subName, array], i) => (
          <div key={i} className={styles.list_multi}>
            <div
              className={`${styles.input_wrapper}
                  ${dropdownOpened === name + subName ? styles.list_on : "off"}`}
              onClick={e => {
                e.stopPropagation();
                setDropdownOpened(dropdownOpened === name + subName ? null : name + subName);
              }}
            >
              <span>{subName}</span>
              <p>{currentSelected[subName]}</p>
              {dropdownOpened === name + subName ? <Unfold /> : <Fold />}
            </div>
            {dropdownOpened === name + subName && (
              <SelectDropDown style={{width: "140px", maxHeight: "217px", left: "0px", top: "1px"}}>
                {array.map((position, i) => (
                  <div
                    key={i}
                    onClick={e => {
                      e.stopPropagation();
                      setCurrentSelected({
                        ...currentSelected,
                        [subName]: position,
                      });
                      setDropdownOpened(null);
                      dropdownOnChange(name + subName, position);
                    }}
                    className={`${position === currentSelected[subName] ? styles.active : ""} ${styles.item}`}
                  >
                    <Check className={position === currentSelected[subName] ? "" : styles.uncheck} />
                    {position}
                  </div>
                ))}
              </SelectDropDown>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default MultipleDropDownInput;
